import { useAuth0 } from "@auth0/auth0-react";
import { makeStyles } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useDataLayerValue } from "../Reducer/DataLayer";
import Card220 from "./ScrollHome/Card220";
import Card60 from "./ScrollHome/Card60";
import Navigation from "./ScrollHome/Navigation";
import SingleNews from "./ScrollHome/SingleNews";
import Story from "./ScrollHome/Story";

const ScrollHome = () => {
  const classes = useStyles(true);

  const { getAccessTokenSilently } = useAuth0();

  const [{ allNews, isMobile }, dispatch] = useDataLayerValue();

  const [isOpen, setIsOpen] = useState(0);

  console.log(allNews);
  useEffect(() => {
    const getAllNews = async () => {
      try {
        const response = await fetch("/.netlify/functions/server/api/allNews");
        const data = await response.json();
        await dispatch({
          type: "ADD_ALL_NEWS",
          payload: { allNews: data },
        });
        await dispatch({
          type: "ADD_STORIES",
          payload: { stories: data?.slice(0, 9) },
        });
      } catch (err) {
        console.error(err.messaage);
      }
    };
    getAllNews();

    var isMobile = navigator.userAgent.split(" ");
    isMobile =
      isMobile.indexOf("Android") !== -1 || isMobile.indexOf("iPhone") !== -1;
    dispatch({
      type: "SET_MOBILE",
      payload: { isMobile },
    });
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <h1>
          News In Seconds{" "}
          <span style={{ fontSize: ".8rem" }}>
            [{isMobile ? "Mobile" : "No Mobile"}
            {" - "}
            {navigator?.connection?.effectiveType}]
          </span>
        </h1>
      </div>

      {false && <Story />}
      <div className={classes.body}>
        <div className={classes.left_body}></div>
        <div className={classes.center_body}>
          {allNews.length > 0 ? (
            allNews?.map((news, index) => (
              <div
                className={classes.card}
                onClick={() => {
                  window.scroll({
                    position: "absolute",
                    // top: 0,
                    left: 0,
                    behavior: "smooth",
                  });
                  setIsOpen(index);
                }}
                key={index}
              >
                {isOpen === index ? (
                  <>
                    {true && <SingleNews news={news} />}
                    {false && <Card220 index={index} news={news} />}
                  </>
                ) : (
                  <Card60 index={index} news={news} />
                )}
              </div>
            ))
          ) : (
            <h1 className="mt-5">Loading...</h1>
          )}
        </div>
        <div className={classes.right_body}></div>
      </div>
      <Navigation />
    </div>
  );
};
export default ScrollHome;

const useStyles = makeStyles((theme, props) => ({
  root: {
    // backgroundColor: "#345679",
    display: "flex",
    flexDirection: "column",
    // width: "100%",
  },
  header: {
    justifyContent: "center",
    backgroundColor: "#8c0a19",
    color: "white",
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    top: "0",
    left: "0",
    height: "3rem",
    width: "100%",
    alignItems: "center",
    zIndex: 10,
  },
  body: {
    display: "flex",
    width: "inherit",
    // backgroundColor: "#666711",
  },
  left_body: {
    flex: 1,
    // backgroundColor: "#666222",
    [theme.breakpoints.down("md")]: {
      flex: 0,
    },
  },
  right_body: {
    flex: 1,
    // backgroundColor: "#333789",
    [theme.breakpoints.down("md")]: {
      flex: 0,
    },
  },
  center_body: {
    flex: 1,
    // backgroundColor: "#666789",
    display: "flex",
    flexDirection: "column",
    margin: "0 0 2.6rem 0",
  },
  card: {
    display: "flex",
    justifyContent: "center",
    margin: ".5rem 0",
    // backgroundColor: "green",
    [theme.breakpoints.down("md")]: {
      margin: ".5rem",
      width: "inherit",
    },
    // top: props => props ===true? 0: "20rem",
  },
}));
